import React, { useContext, useState, useEffect } from "react";
import Context from "../../../Context/Context";
import { useNavigate, useLocation } from "react-router-dom";
import { BsBoxArrowRight } from "react-icons/bs";
import { Auth } from "aws-amplify";
import {
  FaUser,
  FaCalendarAlt,
  FaHistory,
  FaUsers,
  FaVideo,
  FaEnvelope,
  FaBars,
  FaTimes,
  FaTh,
  FaSun,
  FaMoon,
} from "react-icons/fa";
import { RiMoneyDollarCircleFill } from "react-icons/ri";
import logo from "../../../Utils/Svg/Logo.svg";

const LeftBanner = ({ attendance, due, displayAfterClick }) => {
  const UserCtx = useContext(Context);
  const location = useLocation();
  const [click, setClick] = useState("Upcoming Classes");
  const [mobileClick, setMobileClick] = useState("Upcoming Classes");
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { setLoading, loading } = useContext(Context);

  const Navigate = useNavigate();

  // Sync sidebar active state with route
  useEffect(() => {
    if (
      location.pathname === "/dashboard/upcomingsession" ||
      location.pathname === "/dashboard"
    ) {
      setClick("Upcoming Classes");
      setMobileClick("Upcoming Classes");
    } else if (location.pathname === "/dashboard/previoussession") {
      setClick("Previous Classes");
      setMobileClick("Previous Classes");
    } else if (location.pathname === "/dashboard/members") {
      setClick("Members");
      setMobileClick("Members");
    } else if (location.pathname === "/dashboard/choreography") {
      setClick("Choreography");
      setMobileClick("Choreography");
    } else if (location.pathname === "/dashboard/account") {
      setClick("Account");
      setMobileClick("Account");
    } else if (
      location.pathname === "/dashboard/revenue" ||
      location.pathname === "/dashboard/payments"
    ) {
      // Use userType to determine label
      const userType = UserCtx.userData?.userType;
      const label = userType === "admin" ? "Revenue" : "Payments";
      setClick(label);
      setMobileClick(label);
    }
  }, [location.pathname, UserCtx.userData?.userType]);
  const isMember = UserCtx.userData.userType === "member";
  const isAdmin = UserCtx.userData.userType === "admin";
  const isInstructor = UserCtx.userData.userType === "instructor";
  const getInitials = (name) => {
    if (!name) return "";
    const initials = name
      .split(" ")
      .map((word) => word?.charAt(0)?.toUpperCase())
      .join("");
    return initials;
  };
  const getColor = (name) => {
    if (!name) return "#888888";
    const colors = [
      "#FF5733",
      "#33FF57",
      "#5733FF",
      "#FF5733",
      "#33FF57",
      "#5733FF",
      "#FF5733",
      "#33FF57",
      "#5733FF",
      "#FF5733",
      "#33FF57",
      "#5733FF",
    ];
    const index = name.length % colors.length;
    return colors[index];
  };

  const defaultImg =
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSyuNFyw05KSucqjifL3PhDFrZLQh7QAS-DTw&usqp=CAU80-804949_profile-icon-for-the-politics-category-circle-hd.png";

  const ListItem = ({ icon, text, onClickFn }) => {
    const isActive = click === text;
    return (
      <div
        className={`w-full px-4 py-2.5 flex flex-row items-center rounded-md cursor-pointer transition-all duration-200 inter ${
          isActive
            ? "bg-[#FDCF08] text-black font-bold"
            : "text-white hover:bg-[#1a1a1a]"
        }`}
        onClick={onClickFn}
        style={{ fontFamily: "Inter, sans-serif" }}>
        <span className={`mr-3 ${isActive ? "text-black" : "text-white"}`}>
          {icon}
        </span>
        <span className={`text-sm ${isActive ? "font-bold" : "font-medium"}`}>
          {text}
        </span>
      </div>
    );
  };

  const MobileMenuItem = ({ icon, text, onClickFn }) => {
    const isActive = mobileClick === text;
    return (
      <div
        className={`w-full px-6 py-2.5 flex flex-row items-center cursor-pointer transition-all duration-200 rounded-md inter ${
          isActive
            ? "bg-[#FDCF08] text-black font-bold"
            : "text-white hover:bg-[#1a1a1a]"
        }`}
        onClick={() => {
          onClickFn();
          setIsMobileMenuOpen(false);
        }}
        style={{ fontFamily: "Inter, sans-serif" }}>
        <span className={`mr-4 ${isActive ? "text-black" : "text-white"}`}>
          {icon}
        </span>
        <span
          className={`text-sm ${
            isActive ? "font-bold text-black" : "font-medium text-white"
          }`}>
          {text}
        </span>
      </div>
    );
  };

  const handleLogout = async () => {
    try {
      setLoading(true);
      await Auth.signOut();
      setLoading(false);
      window.location.href = "/";
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };

  // Bottom navigation items for mobile - All options
  const bottomNavItems = [
    {
      icon: <FaCalendarAlt size={18} />,
      text: "Upcoming",
      onClick: () => {
        setMobileClick("Upcoming Classes");
        Navigate("/dashboard/upcomingsession");
        displayAfterClick(0);
      },
      activeKey: "Upcoming Classes",
    },
    {
      icon: <FaHistory size={18} />,
      text: "Previous",
      onClick: () => {
        setMobileClick("Previous Classes");
        Navigate("/dashboard/previoussession");
        displayAfterClick(1);
      },
      activeKey: "Previous Classes",
    },
    {
      icon: <FaVideo size={18} />,
      text: "Videos",
      onClick: () => {
        setMobileClick("Choreography");
        displayAfterClick(2);
      },
      activeKey: "Choreography",
    },
    ...(isAdmin
      ? [
          {
            icon: <FaUsers size={18} />,
            text: "Members",
            onClick: () => {
              setMobileClick("Members");
              Navigate("/dashboard/members");
            },
            activeKey: "Members",
          },
        ]
      : []),
    ...((UserCtx.userData?.userType === "admin" ||
      UserCtx.userData?.userType === "member") &&
    !isInstructor
      ? [
          {
            icon: <RiMoneyDollarCircleFill size={18} />,
            text:
              UserCtx.userData?.userType === "admin" ? "Revenue" : "Payments",
            onClick: () => {
              setMobileClick(
                UserCtx.userData?.userType === "admin" ? "Revenue" : "Payments",
              );
              Navigate("/dashboard/revenue");
              displayAfterClick(5);
            },
            activeKey:
              UserCtx.userData?.userType === "admin" ? "Revenue" : "Payments",
          },
        ]
      : []),
    {
      icon: <FaUser size={18} />,
      text: "Account",
      onClick: () => {
        setMobileClick("Account");
        Navigate("/dashboard/account");
        displayAfterClick(3);
      },
      activeKey: "Account",
    },
    {
      icon: <FaEnvelope size={18} />,
      text: "Contact",
      onClick: () => Navigate("/query"),
      activeKey: "Contact",
    },
  ];

  const BottomNavItem = ({ icon, text, onClickFn, isActive }) => {
    return (
      <button
        onClick={onClickFn}
        className={`flex flex-col items-center justify-center gap-0.5 py-1.5 px-3 flex-shrink-0 transition-all duration-200 relative min-w-[65px] ${
          isActive ? "text-[#FDCF08]" : "text-gray-400 active:text-gray-300"
        }`}
        style={{ fontFamily: "Inter, sans-serif" }}>
        <span
          className={`transition-transform duration-200 ${isActive ? "scale-110" : ""}`}>
          {icon}
        </span>
        <span
          className={`text-[10px] font-medium leading-tight whitespace-nowrap ${isActive ? "text-[#FDCF08]" : "text-gray-400"}`}>
          {text}
        </span>
        {isActive && (
          <span className="absolute top-0 left-1/2 transform -translate-x-1/2 w-1 h-1 bg-[#FDCF08] rounded-full"></span>
        )}
      </button>
    );
  };

  return (
    <>
      {/* Mobile Bottom Navigation Bar */}
      <div className="fixed bottom-0 left-0 right-0 z-50 min800:hidden bg-black border-t border-[#2a2a2a] shadow-[0_-4px_20px_rgba(0,0,0,0.3)]">
        <div className="overflow-x-auto overflow-y-hidden scrollbar-hide safe-area-inset-bottom">
          <div className="flex items-center px-2 py-2 min-w-max gap-1">
            {bottomNavItems.map((item, index) => (
              <BottomNavItem
                key={index}
                icon={item.icon}
                text={item.text}
                onClickFn={item.onClick}
                isActive={mobileClick === item.activeKey}
              />
            ))}
          </div>
        </div>
      </div>

      {/* Enhanced mobile slide-in menu for "More" options */}
      <div
        className={`fixed top-0 left-0 z-40 w-72 h-full bg-black shadow-2xl transform transition-transform duration-300 ease-out min800:hidden flex flex-col ${
          isMobileMenuOpen ? "translate-x-0" : "-translate-x-full"
        }`}>
        <div className="h-full overflow-y-auto flex flex-col">
          {/* Logo Section */}
          <div className="px-6 py-6">
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 bg-[#FDCF08] rounded flex items-center justify-center">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8 2L9.5 6L13.5 7.5L9.5 9L8 13L6.5 9L2.5 7.5L6.5 6L8 2Z"
                    fill="black"
                    stroke="black"
                    strokeWidth="0.5"
                  />
                  <path
                    d="M8 4L9 6.5L11.5 7.5L9 8.5L8 11L7 8.5L4.5 7.5L7 6.5L8 4Z"
                    fill="black"
                  />
                </svg>
              </div>
              <span
                className="text-white text-xl font-bold uppercase tracking-tight"
                style={{ fontFamily: "Inter, sans-serif" }}>
                BWORKZ
              </span>
            </div>
          </div>

          {/* Enhanced menu items */}
          <div className="py-2 flex flex-col flex-1 px-4">
            {/* OVERVIEW Section */}
            <div className="mb-5">
              <div className="px-2 py-2 mb-1.5">
                <span
                  className="text-xs font-semibold text-[#888888] uppercase tracking-wider"
                  style={{ fontFamily: "Inter, sans-serif" }}>
                  OVERVIEW
                </span>
              </div>
              <div className="flex flex-col gap-0.5">
                <MobileMenuItem
                  icon={<FaCalendarAlt size={16} />}
                  text="Upcoming Classes"
                  onClickFn={() => {
                    setMobileClick("Upcoming Classes");
                    Navigate("/dashboard/upcomingsession");
                    displayAfterClick(0);
                  }}
                />
                <MobileMenuItem
                  icon={<FaHistory size={16} />}
                  text="Previous Classes"
                  onClickFn={() => {
                    setMobileClick("Previous Classes");
                    Navigate("/dashboard/previoussession");
                    displayAfterClick(1);
                  }}
                />
              </div>
            </div>

            {/* MANAGEMENT Section */}
            <div className="mb-5">
              <div className="px-2 py-2 mb-1.5">
                <span
                  className="text-xs font-semibold text-[#888888] uppercase tracking-wider"
                  style={{ fontFamily: "Inter, sans-serif" }}>
                  MANAGEMENT
                </span>
              </div>
              <div className="flex flex-col gap-0.5">
                <MobileMenuItem
                  icon={<FaVideo size={16} />}
                  text="Choreography"
                  onClickFn={() => {
                    setMobileClick("Choreography");
                    Navigate("/dashboard/choreography");
                    displayAfterClick(2);
                  }}
                />
                {isAdmin && (
                  <MobileMenuItem
                    icon={<FaUsers size={16} />}
                    text="Members"
                    onClickFn={() => {
                      setMobileClick("Members");
                      Navigate("/dashboard/members");
                    }}
                  />
                )}
                {!isInstructor && (
                  <MobileMenuItem
                    icon={<RiMoneyDollarCircleFill size={16} />}
                    text={
                      UserCtx.userData?.userType === "admin"
                        ? "Revenue"
                        : "Payments"
                    }
                    onClickFn={() => {
                      setMobileClick(
                        UserCtx.userData?.userType === "admin"
                          ? "Revenue"
                          : "Payments",
                      );
                      Navigate("/dashboard/revenue");
                      displayAfterClick(5);
                    }}
                  />
                )}
              </div>
            </div>
            {/* {isAdmin && (
              <MobileMenuItem
                icon={<FaEdit size={16} />}
                text="Subscriptions"
                onClickFn={() => {
                  const baseUrl =
                    process.env.NODE_ENV === "development"
                      ? "http://localhost:3000"
                      : process.env.REACT_APP_STAGE === "PROD"
                      ? institutionData.PROD_DOMAIN
                      : institutionData.BETA_DOMAIN;

                  const url = `${baseUrl}/allpayment/${
                    institutionData.InstitutionId
                  }/${UserCtx.cognitoId}/${
                    UserCtx.emailId
                  }?primary=${encodeURIComponent(
                    InstitutionData.PrimaryColor.replace("#", "")
                  )}&secondary=${encodeURIComponent(
                    InstitutionData.SecondaryColor.replace("#", "")
                  )}`;
                  window.open(url, "_blank", "noopener,noreferrer");
                }}
              />
            )} */}

            {/* Account section */}
            <div className="mb-5">
              <div className="px-2 py-2 mb-1.5">
                <span
                  className="text-xs font-semibold text-[#888888] uppercase tracking-wider"
                  style={{ fontFamily: "Inter, sans-serif" }}>
                  Account
                </span>
              </div>
              <div className="flex flex-col gap-0.5">
                <MobileMenuItem
                  icon={<FaUser size={16} />}
                  text="Account"
                  onClickFn={() => {
                    setMobileClick("Account");
                    Navigate("/dashboard/account");
                    displayAfterClick(3);
                  }}
                />
                <MobileMenuItem
                  icon={<FaEnvelope size={16} />}
                  text="Contact Us"
                  onClickFn={() => Navigate("/query")}
                />
              </div>
            </div>

            {/* Enhanced logout section */}
            <div className="px-6 pb-6 pt-4 border-t border-[#2a2a2a]">
              <div
                className="w-full px-4 py-2.5 flex items-center gap-3 text-red-500 cursor-pointer hover:opacity-80 transition-opacity"
                onClick={handleLogout}
                style={{ fontFamily: "Inter, sans-serif" }}>
                {loading ? (
                  <>
                    <div className="animate-spin h-4 w-4 border-2 border-red-500 border-t-transparent rounded-full"></div>
                    <span className="font-medium text-sm">Signing out...</span>
                  </>
                ) : (
                  <>
                    <BsBoxArrowRight size={18} className="text-red-500" />
                    <span className="font-medium text-sm text-red-500">
                      Logout
                    </span>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Enhanced overlay */}
      {isMobileMenuOpen && (
        <div
          className="fixed inset-0 bg-black/50 backdrop-blur-sm z-30 min800:hidden transition-opacity duration-300"
          onClick={() => setIsMobileMenuOpen(false)}></div>
      )}

      {/* Close button for mobile menu */}
      {isMobileMenuOpen && (
        <div className="fixed top-4 left-4 z-[49] min800:hidden">
          <button
            className="p-3 bg-[#FDCF08] rounded-lg shadow-lg border-2 border-black focus:outline-none hover:bg-[#f0c000] transition-colors"
            onClick={() => setIsMobileMenuOpen(false)}>
            <FaTimes className="w-5 h-5 text-black" />
          </button>
        </div>
      )}

      {/* Desktop Sidebar */}
      <div
        className="w-[19rem] relative max800:hidden bg-black h-[calc(100vh-4rem)] flex flex-col"
        style={{ fontFamily: "Inter, sans-serif" }}>
        <nav className="flex flex-col h-full">
          {/* Navigation Menu */}
          <div className="flex-1 overflow-y-auto px-4 py-2">
            {/* OVERVIEW Section */}
            <div className="mb-5">
              <div className="px-2 py-2 mb-1.5">
                <span
                  className="text-xs font-semibold text-[#888888] uppercase tracking-wider"
                  style={{ fontFamily: "Inter, sans-serif" }}>
                  OVERVIEW
                </span>
              </div>
              <div className="flex flex-col gap-0.5">
                <ListItem
                  icon={<FaCalendarAlt size={18} />}
                  text="Upcoming Classes"
                  onClickFn={() => {
                    setClick("Upcoming Classes");
                    Navigate("/dashboard/upcomingsession");
                    displayAfterClick(0);
                  }}
                />
                <ListItem
                  icon={<FaHistory size={18} />}
                  text="Previous Classes"
                  onClickFn={() => {
                    setClick("Previous Classes");
                    Navigate("/dashboard/previoussession");
                    displayAfterClick(1);
                  }}
                />
              </div>
            </div>

            {/* MANAGEMENT Section */}
            <div className="mb-5">
              <div className="px-2 py-2 mb-1.5">
                <span
                  className="text-xs font-semibold text-[#888888] uppercase tracking-wider"
                  style={{ fontFamily: "Inter, sans-serif" }}>
                  MANAGEMENT
                </span>
              </div>
              <div className="flex flex-col gap-0.5">
                <ListItem
                  icon={<FaVideo size={18} />}
                  text="Choreography"
                  onClickFn={() => {
                    setClick("Choreography");
                    Navigate("/dashboard/choreography");
                    displayAfterClick(2);
                  }}
                />
                {UserCtx.userData.userType === "admin" && (
                  <ListItem
                    icon={<FaUsers size={18} />}
                    text="Members"
                    onClickFn={() => {
                      setClick("Members");
                      Navigate("/dashboard/members");
                    }}
                  />
                )}
                {(UserCtx.userData?.userType === "admin" ||
                  UserCtx.userData?.userType === "member") && (
                  <ListItem
                    icon={<RiMoneyDollarCircleFill size={18} />}
                    text={
                      UserCtx.userData?.userType === "admin"
                        ? "Revenue"
                        : "Payments"
                    }
                    onClickFn={() => {
                      setClick(
                        UserCtx.userData?.userType === "admin"
                          ? "Revenue"
                          : "Payments",
                      );
                      Navigate("/dashboard/revenue");
                      displayAfterClick(5);
                    }}
                  />
                )}
              </div>
            </div>

            {/* Account Section */}
            <div className="mb-5">
              <div className="px-2 py-2 mb-1.5">
                <span
                  className="text-xs font-semibold text-[#888888] uppercase tracking-wider"
                  style={{ fontFamily: "Inter, sans-serif" }}>
                  Account
                </span>
              </div>
              <div className="flex flex-col gap-0.5">
                <ListItem
                  icon={<FaUser size={18} />}
                  text="Account"
                  onClickFn={() => {
                    setClick("Account");
                    Navigate("/dashboard/account");
                    displayAfterClick(3);
                  }}
                />
                <ListItem
                  icon={<FaEnvelope size={18} />}
                  text="Contact Us"
                  onClickFn={() => Navigate("/query")}
                />
              </div>
            </div>
          </div>

          {/* Logout Section */}
          <div className="px-4 pb-6 pt-4 border-t border-[#2a2a2a]">
            <div
              className="w-full px-4 py-2.5 flex items-center gap-3 text-red-500 cursor-pointer hover:opacity-80 transition-opacity"
              onClick={handleLogout}
              style={{ fontFamily: "Inter, sans-serif" }}>
              {loading ? (
                <>
                  <div className="animate-spin h-4 w-4 border-2 border-red-500 border-t-transparent rounded-full"></div>
                  <span className="font-medium text-sm">Signing out...</span>
                </>
              ) : (
                <>
                  <BsBoxArrowRight size={18} className="text-red-500" />
                  <span className="font-medium text-sm text-red-500">
                    Logout
                  </span>
                </>
              )}
            </div>
          </div>
        </nav>
      </div>
    </>
  );
};

export default LeftBanner;
